/**
 * Directive to show the quickshop overlay.
 */
Vue.directive("cyt-quickshop-show", {
    bind(el, binding)
    {
        el.addEventListener("click", (evt) => {
            window.ceresStore.dispatch("showOverlay", binding.value);
        });
    }
});
